import { render } from "./ctacte.vue?vue&type=template&id=08f56278"
import script from "./ctacte.vue?vue&type=script&lang=js"
export * from "./ctacte.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__